import React from 'react';

var NewWindow = function NewWindow(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M19 6.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L17.586 5H15a1 1 0 0 1 0-2h5a.997.997 0 0 1 1 1v5a1 1 0 0 1-2 0V6.414zm-2 7.409a1 1 0 0 1 2 0V16a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V9a4 4 0 0 1 4-4h2.208a1 1 0 0 1 0 2H8a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2v-2.177z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

NewWindow.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { NewWindow as icon };
export default iconHandler(NewWindow);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/NewWindow.js
// module id = 615
// module chunks = 0